import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services';
import { environment } from '../../../environments/environment';
import { IUpdateThemeColsAssignList } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SearchThemeColumnsAssignService {
    constructor(private http: HttpClient,
        private apiService: ApiService) { }
        public getSearchPageColumns(id:number):Observable<any> {
            return this.apiService.get(`SearchPageColumns/GetSearchPageColumnsBySearchPageId/${id}`)
        }
        public getThemeNames(id:number):Observable<any> {
          return this.apiService.get(`SearchPageTheme/GetSearchPageThemesBySearchPageId/${id}`);
      }
      public getThemeColsAssignList(searhPageId:number,themeId:number):Observable<any> {
        return this.apiService.get(`SearchPageThemeColsAssign/GetSearchPageThemeColsAssignList/${searhPageId}/${themeId}`)
    }
    public getThemeId(searhPageId:number):Observable<any> {
      return this.apiService.get(`SearchPageThemeColsAssign/GetThemeIdForPage/${searhPageId}`)
  }
    public updateThemeColsAssignList(themeColAssignUpdate:IUpdateThemeColsAssignList):Observable<any> {
      console.log(themeColAssignUpdate);
      return this.apiService.post(`SearchPageThemeColsAssign/UpdateSearchPageThemeColAssign`,themeColAssignUpdate);
  }
  public updateSearchPageDefaultTheme(userId:number,themeId:number,searhPageId:number):Observable<any> {
    return this.apiService.get(`SearchPageThemeUserAssignment/SearchPageDefaultThemeUpdate/${userId}/${themeId}/${searhPageId}`)
  }
}